import { render, staticRenderFns } from "./explainer-change-request-form.vue?vue&type=template&id=dc04cbb6&scoped=true&"
import script from "./explainer-change-request-form.vue?vue&type=script&lang=js&"
export * from "./explainer-change-request-form.vue?vue&type=script&lang=js&"
import style0 from "./explainer-change-request-form.vue?vue&type=style&index=0&id=dc04cbb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc04cbb6",
  null
  
)

export default component.exports